import "./style/LoadingLogo.css";

export default function LoadingLogo() {
  return (
    <div className="loading-overlay">
      <div className="rotating-bow">
        <div className="bow-container">
          <div className="bow-letter-col">
            <span className="bow-letter">B</span>
            <div className="bow-vertical">
              <span>E</span>
            </div>
          </div>
          <span className="bow-dot">•</span>
          <div className="bow-letter-col">
            <span className="bow-letter">O</span>
            <div className="bow-vertical">
              <span>N</span>
            </div>
          </div>
          <span className="bow-dot">•</span>
          <div className="bow-letter-col">
            <span className="bow-letter">W</span>
            <div className="bow-vertical">
              <span>A</span>
              <span>L</span>
              <span>L</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
